export const elmoExperimentResourceNames = {
  default: 'GOPS_smarthelp',
  pcc: 'GOPS_smarthelp_pcc',
  kmSearch: 'GOPS_smarthelp_km_search',
  nnaDesign: 'CustomerSupport:NNAExperiances',
  updateContextPrompt: 'GOPS_smarthelp_Update_context_prompt',
  nativeMessagingExperience: 'GOPS_smarthelp_native_messaging_in_venice',
  searchLimiterResourceName: 'GOPS_smarthelp_Search_Limiter_Exp',
};

export const elmoTreatmentNames = {
  nnaEnabled: 'Trmt_CustomerSupportR_NNAExperiances_By_Channel',
  updateContextTreatment: 'Trmt_GOPS_Helpcenter_Update_Context_prompt_Exp',
  nativeMessagingEnabled: 'Trmt_GOPS_Helpcenter_Native_Messaging_In_Venice_Enabled',
  searchLimiterTreatmentName: 'Trmt_GOPS_Helpcenter_Search_Limiter_Exp',
};

export const isPartOfElmoExpTreatment = (elmoTreatments, treatmentName) => (Array.isArray(elmoTreatments) && elmoTreatments.indexOf(treatmentName) >= 0);
